import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Adicione os ícones necessários à biblioteca
library.add(faInstagram)

export { FontAwesomeIcon }
